export enum PayFrequency {
  BI_WEEKLY = 'BI_WEEKLY',
  MONTHLY = 'MONTHLY',
  TWICE_MONTHLY = 'TWICE_MONTHLY',
  WEEKLY = 'WEEKLY',
  YEARLY = 'YEARLY',
}
